// To identify users that landed on the quiz/quiz results page from the modals
export const setGoogleOneTapQuizSource = ({
  source,
}: {
  source: 'create_account_modal' | 'log_in_flyout'
}) => sessionStorage.setItem('quiz_entry_source', source)

// To identify users that clicked on the signup with email or login button of variant_2
export const setGoogleOneTapSignupClicked = () => {
  sessionStorage.setItem('google_one_tap_signup_clicked', 'true')
}

export const getGoogleOneTapSignupClicked = () => {
  const signUpClicked = sessionStorage.getItem('google_one_tap_signup_clicked')
  sessionStorage.removeItem('google_one_tap_signup_clicked')
  return signUpClicked
}
